import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonSpinner, IonTitle, IonToolbar, MenuController, ModalController } from '@ionic/angular';
import {
    ApplicationContextStore,
    AppService,
    AuthService,
    NamedRoutes,
    RouterService,
    StorageService,
    ToastService,
    TranslationPipe,
    TranslationService,
} from '@raptor-fe/services';
import { AsyncPipe } from '@angular/common';
import { FeatureFlagTypes, Permissions, SharedEnvironment, WINDOW_TOKEN } from '@raptor-fe/core';
import { SelectBranchModalComponent } from '../modals/select-branch-modal/select-branch-modal.component';
import { LanguageModalComponent } from '../modals/language-modal/language-modal.component';
import { Browser } from '@capacitor/browser';

@Component({
    selector: 'lib-mobile-menu',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `        
    @if(applicationContext.dictionary()) {
        <ion-menu side="end" menuId="custom" contentId="main-content" type="overlay" (ionWillOpen)="applicationContext.fetchWorkDayClockStatus()">
            <ion-header>
                <ion-toolbar>
                    <ion-title class="text-xs px-2" (click)="!applicationContext.isSingleBranchUser() ? openModal() : null">
                        {{ applicationContext.branch().name }}
                    </ion-title>
                    @if (!applicationContext.isSingleBranchUser()) {
                        <ion-buttons slot="end">
                            <ion-button (click)="openModal()">
                                <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                    }
                </ion-toolbar>
                <ion-toolbar>                              
                    <ion-title class="text-sm px-2">
                        {{ { feature: "Common", component: "Menu", label: "Welcome" } | translate }}, {{ applicationContext.displayName() }}
                    </ion-title>                                
                </ion-toolbar>
                @if(hasDailyClockInFeatureEnabled()) {
                <ion-button expand="block" size="small" class="mx-4" fill="outline" (click)="toggleDayClockedIn()" [disabled]="applicationContext.isLoadingWorkDayClockStatus()">
                    @if(applicationContext.isLoadingWorkDayClockStatus()){
                        <ion-spinner  name="dots"></ion-spinner>
                    }@else {
                            {{ applicationContext.isWorkDayClockedIn() ? ({ feature: "Common", component: "Menu", label: "Clock Out" } | translate) : ({ feature: "Common", component: "Menu", label: "Clock In" } | translate) }}
                            <ion-icon slot="start" name="time" [color]="applicationContext.isWorkDayClockedIn() ? 'danger' : 'success'"></ion-icon>
                    }
                </ion-button>
                }
            </ion-header>
            <ion-content class="no-scroll">
                <ion-list>                    
                    @if(canShowChangeLanguage()){
                     <ion-menu-toggle>
                        <ion-item class="menu-button no-border" lines="none" (click)="openLanguageModal()">
                            <ion-label> {{ { feature: "Common", component: "Menu", label: "Change Language" } | translate }} </ion-label>
                            <ion-icon slot="end" class="no-border pr-4" src="public/language.svg"></ion-icon>
                        </ion-item>
                    </ion-menu-toggle>
                    }

                    @if(canShowCheckIn()){
                      <ion-menu-toggle>
                        <ion-item class="menu-button no-border" lines="none" (click)="navigateToCheckIn()">
                            <ion-label> {{ { feature: "Common", component: "Menu", label: "Check-In" } | translate }} </ion-label>
                            <ion-icon slot="end" class="no-border pr-4 menu-icon" name="checkbox-outline"></ion-icon>
                        </ion-item>
                    </ion-menu-toggle>
                    }

                    @if(canShowDvi()){
                    <ion-menu-toggle>
                        <ion-item class="menu-button no-border" lines="none" (click)="navigateToDvi()">
                            <ion-label>
                                {{ { feature: "Common", component: "Menu", label: "DVI" } | translate }}
                            </ion-label>
                            <ion-icon slot="end" class="no-border pr-4" src="public/dvi.svg"></ion-icon>                
                        </ion-item>
                    </ion-menu-toggle>
                    }

                    @if(canShowInventory()){
                    <ion-menu-toggle>
                        <ion-item class="menu-button no-border" lines="none" (click)="navigateToInventoryCounting()">
                            <ion-label>
                                {{ { feature: "Common", component: "Menu", label: "Inventory" } | translate }}
                            </ion-label>
                            <ion-icon slot="end" class="no-border pr-4" src="public/barcode-outline.svg"></ion-icon>
                        </ion-item>
                    </ion-menu-toggle>
                    }

                    @if(hasTechWorkFeatureEnabled()){
                    <ion-menu-toggle>
                        <ion-item class="menu-button no-border" lines="none" (click)="navigateToTechWork()">
                            <ion-label>
                                {{ { feature: "Common", component: "Menu", label: "My Work" } | translate }}
                            </ion-label>
                            <ion-icon slot="end" class="no-border pr-4 menu-icon" name="briefcase-outline"></ion-icon>
                        </ion-item>
                    </ion-menu-toggle>
                    }

                    @if(canShowPrivacyPolicy()){
                    <ion-item color="" class="menu-button no-border" lines="none" (click)="openPrivacyPage()">
                        <ion-label>
                            {{ { feature: "Common", component: "Menu", label: "Privacy Policy" } | translate }}
                        </ion-label>
                        <ion-icon slot="end" class="no-border pr-4" src="public/privacy.svg"></ion-icon>
                    </ion-item>
                    }

                     <ion-menu-toggle>
                        <ion-item color="" class="menu-button no-border" lines="none" (click)="logOut()">
                            <ion-label>
                            {{ { feature: "Common", component: "Menu", label: "Logout" } | translate }}
                            </ion-label>
                            <ion-icon slot="end" class="no-border pr-4" src="public/logout.svg"></ion-icon>                
                        </ion-item>
                    </ion-menu-toggle>
                </ion-list>
            </ion-content>
                <ion-footer>                            

                <ion-item color="ion-primary mr-6" class="no-border" lines="none">
                        <p class="version-code">{{ { feature: "Common", component: "Menu", label: "Version" } | translate }}: {{ (this.appService.appInfo$ | async)?.version }}</p>
                </ion-item>

            </ion-footer>
        </ion-menu>            
    } @else {
        <ion-spinner color="white" name="dots"></ion-spinner>
    }
    `,
    styles: [
        `
            .menu-button {
            margin-top: 16px;
            margin-left: 24px;
            margin-right: 24px;
            --background: var(--ion-color-primary);
            --border-radius: 12px;
            --color: white;
            --inner-padding-bottom: 0px;
            --inner-padding-end: 0px;
            --inner-padding-start: 0px;
            --inner-padding-top: 0px;
            --min-height: 72px;
        }`,
        `
            .menu-icon {
            color: #c2d9e3;
        }`,
    ],
    imports: [IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonSpinner, IonTitle, IonToolbar, TranslationPipe, AsyncPipe],
    providers: [],
})
export class MobileMenuComponent {
    private readonly authService = inject(AuthService);
    private readonly browserWindow = inject(WINDOW_TOKEN);
    private readonly menu = inject(MenuController);
    private readonly modalController = inject(ModalController);
    private readonly routerService = inject(RouterService);
    private readonly translationService = inject(TranslationService);
    protected readonly toastService = inject(ToastService);
    protected readonly storage = inject(StorageService);

    protected readonly appService = inject(AppService);
    protected readonly applicationContext = inject(ApplicationContextStore);

    environment = input.required<SharedEnvironment>();

    protected readonly hasCheckInFeatureEnabled = signal(false);
    protected readonly hasInspectionFeatureEnabled = signal(false);
    protected readonly hasInventoryCountFeatureEnabled = signal(false);
    protected readonly hasTimeClockFeatureEnabled = signal(false);
    protected readonly hasDailyClockInFeatureEnabled = signal(false);
    protected readonly hasTechWorkFeatureEnabled = signal(false);
    protected isSingleBranchUser = signal(false);

    /**
     * Whether the Check-In menu entry is visible. Requires the Check-In feature flag and the
     * appointment view permission; check-in is an appointment-centric flow, so its menu visibility
     * is gated by the appointment :view key.
     */
    protected readonly canShowCheckIn = computed(
        () => this.hasCheckInFeatureEnabled() && this.applicationContext.hasPermission(Permissions.Appointment.View),
    );

    /**
     * Whether the DVI menu entry is visible. Requires the inspection feature flag plus the
     * inspection list-view permission. This key is distinct from inspection:view (which continues to
     * gate individual inspection detail, create, and edit routes) so tenants can suppress the mobile
     * DVI list surface for a role without stripping the rest of the DVI feature -- for example, on
     * marlin-mobile a technician tenant configuration typically revokes inspection:listview so the
     * technician's landing page is not shadowed by the redundant generic list, while the same
     * technician still opens inspections through the tech-work "My Work" flow.
     */
    protected readonly canShowDvi = computed(
        () => this.hasInspectionFeatureEnabled() && this.applicationContext.hasPermission(Permissions.Inspection.ListView),
    );

    /**
     * Number of languages the current instance offers, or null until the list has loaded. Null is
     * treated as "show" so a slow or failed lookup never hides an otherwise-usable control.
     */
    private readonly availableLanguageCount = signal<number | null>(null);

    /**
     * Whether the Change Language entry is visible. A single-language instance has nothing to switch
     * to, so the entry is hidden once the list is known to hold one or fewer languages.
     */
    protected readonly canShowChangeLanguage = computed(() => {
        const count = this.availableLanguageCount();
        return count === null || count > 1;
    });

    /**
     * Whether the Privacy Policy entry is visible. Shown unless the environment explicitly opts out.
     */
    protected readonly canShowPrivacyPolicy = computed(() => this.environment().menu?.privacyPolicy !== false);

    /**
     * Whether the Inventory menu entry is visible. Requires the inventory count feature flag and the
     * inventory view permission.
     */
    protected readonly canShowInventory = computed(
        () => this.hasInventoryCountFeatureEnabled() && this.applicationContext.hasPermission(Permissions.Inventory.View),
    );

    constructor() {
        this.translationService
            .getAvailableLanguages()
            .pipe(takeUntilDestroyed())
            .subscribe({
                next: (languages) => this.availableLanguageCount.set(languages.length),
            });

        effect(() => {
            const features = this.applicationContext.features();
            this.hasCheckInFeatureEnabled.set(features.includes(FeatureFlagTypes.CheckIn));
            this.hasInspectionFeatureEnabled.set(features.includes(FeatureFlagTypes.DigitalVehicleInspection));
            this.hasInventoryCountFeatureEnabled.set(features.includes(FeatureFlagTypes.InventoryCount));
            this.hasTimeClockFeatureEnabled.set(features.includes(FeatureFlagTypes.TimeClock));
            this.hasDailyClockInFeatureEnabled.set(features.includes(FeatureFlagTypes.DailyClockIn));
            this.hasTechWorkFeatureEnabled.set(features.includes(FeatureFlagTypes.TechWorkView));
        });
    }

    protected async openModal(): Promise<void> {
        const modalData = await SelectBranchModalComponent.show(this.modalController, true);
        if (modalData !== undefined) {
            this.closeMenu();
            await this.routerService.navigateAndReplaceUrl(NamedRoutes.inspectionList());
            this.browserWindow.location.reload();
        }
    }

    protected closeMenu(): void {
        this.menu.close();
    }

    protected logOut(): void {
        this.authService.logout();
        this.closeMenu();
    }

    protected async openPrivacyPage(): Promise<void> {
        await Browser.open({ url: this.environment().privacy });
    }

    protected async navigateToStocktake(): Promise<void> {
        this.routerService.navigateTo(NamedRoutes.stocktake());
        this.closeMenu();
    }

    protected openLanguageModal(): void {
        this.modalController.create({ component: LanguageModalComponent }).then((modalElement) => {
            modalElement.present();
        });
    }

    protected navigateToDvi(): void {
        this.routerService.navigateTo(NamedRoutes.inspectionList());
    }

    protected navigateToInventoryCounting(): void {
        this.routerService.navigateTo(NamedRoutes.inventoryCounting());
    }

    protected navigateToTechWork(): void {
        this.routerService.navigateTo(NamedRoutes.techWork());
    }

    protected navigateToCheckIn(): void {
        this.routerService.navigateTo(NamedRoutes.checkInSearch());
    }

    protected async toggleDayClockedIn(): Promise<void> {
        const isCheckedIn = this.applicationContext.isWorkDayClockedIn();
        const result = await this.toastService.showYesOrNoQuestion(
            `Clock ${isCheckedIn ? 'Out' : 'In'}`,
            `Are you sure you want to ${isCheckedIn ? 'clock out' : 'clock in'} for the work day?`,
        );

        if (result) {
            this.applicationContext.toggleDayClockedIn();
        }
    }
}
